import { httpRequest } from '@/utils/request'
import { CommonResponse } from '@/types'

export interface User {
  username: string
  password: string
  rememberMe?: boolean
}

export function Login<T> (data: User) {
  return httpRequest<any, CommonResponse<T>>({
    url: '/api/v1/auth/login',
    method: 'post',
    data,
  })
}

export interface ChangePasswordPayload {
  currentPassword: string
  newPassword: string
}

export function changePassword <T> (data: ChangePasswordPayload) {
  return httpRequest<any, CommonResponse<T>>({
    url: '/api/v1/auth/password',
    method: 'put',
    data,
  })
}

export function getInitInfo<T> () {
  return httpRequest<any, CommonResponse<T>>({
    url: '/api/v1/auth/initInfo',
    method: 'get',
  })
}

export function initPassword<T> (data: any) {
  return httpRequest<any, CommonResponse<T>>({
    url: '/api/v1/auth/init-password',
    method: 'post',
    data,
  })
}

export interface ProfileData {
  authorization_revision: string
  id: string
  username: string
  nickname: string
  email: string
  phone: string
  avatar: string
  lang: string
  is_admin: boolean
  tenant_id: string
  role: string
  role_level: number
  permissions: Array<{ resource: string; action: string }>
  last_login_time: number
  last_login_ip: string
  login_count: number
  created: number
  modified: number
}

export interface UpdateProfilePayload {
  nickname?: string
  email?: string
  phone?: string
  avatar?: string
  lang?: string
}

export function getProfile () {
  return httpRequest<any, CommonResponse<ProfileData>>({
    url: '/api/v1/auth/profile',
    method: 'get',
  })
}

export function updateProfile (data: UpdateProfilePayload) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/auth/profile',
    method: 'put',
    data,
  })
}

export function checkPasswordStrength (password: string) {
  return httpRequest<any, CommonResponse<{ strength: number; issues: string[] }>>({
    url: '/api/v1/auth/password-strength',
    method: 'post',
    data: { password },
  })
}

export function logout () {
  return httpRequest<any, CommonResponse<null>>({ url: '/api/v1/auth/logout', method: 'post' })
}

export function getAuthorizationVersion () {
  return httpRequest<any, CommonResponse<{ version: string }>>({
    url: '/api/v1/auth/authorization-version', method: 'get',
  })
}
